import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CANCEL_KEYS } from '@adsk/docs-http-client';
import { AWS_S3_FILE_SIZE_LIMIT } from '@adsk/docs-oss-sdk';

// Re-export client token key
export { CANCEL_KEYS, AWS_S3_FILE_SIZE_LIMIT };
export var DOCS_REGIONS = {
  US: 'US',
  EMEA: 'EMEA',
  FEDRAMP: 'FEDRAMP',
  APAC: 'APAC',
  AUS: 'AUS'
};
export var DOCS_ENVS = {
  QA: 'QA',
  STAGING: 'STAGING',
  PRODUCTION: 'PRODUCTION'
};
export var DOCS_PRODUCTS = {
  ACC: 'ACC',
  BIM: 'BIM'
};
export var HOST_URL = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, DOCS_ENVS.QA, 'https://developer-stg.api.autodesk.com'), DOCS_ENVS.STAGING, 'https://developer-stg.api.autodesk.com'), DOCS_ENVS.PRODUCTION, 'https://developer.api.autodesk.com'), DOCS_REGIONS.FEDRAMP, _defineProperty(_defineProperty({}, DOCS_ENVS.STAGING, 'https://api-stg.afg.us.autodesk.com'), DOCS_ENVS.PRODUCTION, 'https://api.afg.us.autodesk.com'));
export var HOST_CONFIG = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, DOCS_ENVS.QA, {
  // Paths
  DOCS_API_CPV1: '/dm-staging/v1/cmd-qa',
  DS_V2: '/derivativeservice/v2',
  MD_V2: '/modelderivative/v2',
  DOCS_API_V1: '/ea-dm-qa/v1',
  DOCS_API_V2: '/dm-qa/v2',
  DOCS_API_V3: '/dm-qa/v3',
  PKG_API_V1: '/packages-qa/v1',
  EXPORT_API_V1: '/pes-qa/v1',
  EXPORT_API_V2: '/pes-qa/v2',
  REPORT_API_V2: '/reports-qa/v2',
  HQ_API_ADMIN_V1: '/bim360-qa/admin/v1',
  HQ_API_ADMIN_V2: '/bim360-qa/admin/v2',
  OSS_EXT_V2: '/oss-ext/v2',
  RVT_UPGRADE_V1: '/dev/revitupgrader/v1',
  PADD_V1: '/proxy/bridge/v1',
  PADD_V2: '/proxy/bridge/v2',
  OXYGEN_V1: '/identity/v1',
  ACC_ADMIN_V1: '/construction-qa/admin/v1',
  QTO_V1: '/qto-qa/v1',
  DATA_V1: '/forge-dm-qa/data/v1',
  BC_INTERNAL: '/construction/buildingconnected/internal',
  // Hosts
  DOWNLOAD_HOST: 'https://download.docs.b360-qa.autodesk.com',
  MARKUP_HOST: 'https://plangrid-c-api-dispatcher-dev.planfront.net',
  PG_HOST: 'https://io.plangrid-dev.planfront.net',
  BEBOP_V1: '/bebop/v1',
  SPECS_V1: '/construction/specs-qa/v1',
  AUTOMATION_V1: '/automate-qa/v1'
}), DOCS_ENVS.STAGING, {
  // Paths
  DOCS_API_CPV1: '/dm-staging/v1/cmd-staging',
  DS_V2: '/derivativeservice/v2',
  MD_V2: '/modelderivative/v2',
  DOCS_API_V1: '/dm-staging/v1',
  DOCS_API_V2: '/dm/v2',
  DOCS_API_V3: '/dm/v3',
  PKG_API_V1: '/packages/v1',
  EXPORT_API_V1: '/pes/v1',
  EXPORT_API_V2: '/pes/v2',
  REPORT_API_V2: '/reports/v2',
  HQ_API_ADMIN_V1: '/bim360/admin/v1',
  HQ_API_ADMIN_V2: '/bim360/admin/v2',
  OSS_EXT_V2: '/oss-ext/v2',
  RVT_UPGRADE_V1: '/revitupgrader/v1',
  PADD_V1: '/proxy/bridge/v1',
  PADD_V2: '/proxy/bridge/v2',
  OXYGEN_V1: '/identity/v1',
  ACC_ADMIN_V1: '/construction/admin/v1',
  QTO_V1: '/qto/v1',
  DATA_V1: '/data/v1',
  BC_INTERNAL: '/construction/buildingconnected/internal',
  // Hosts
  DOWNLOAD_HOST: 'https://download.docs.b360-staging.autodesk.com',
  MARKUP_HOST: 'https://plangrid-c-api-dispatcher-test.planfront.net',
  PG_HOST: 'https://io.plangrid-test.planfront.net',
  BEBOP_V1: '/bebop/v1',
  SPECS_V1: '/construction/specs/v1',
  AUTOMATION_V1: '/automate/v1'
}), DOCS_ENVS.PRODUCTION, {
  // Paths
  DOCS_API_CPV1: '/dm/v1',
  DS_V2: '/derivativeservice/v2',
  MD_V2: '/modelderivative/v2',
  DOCS_API_V1: '/dm/v1',
  DOCS_API_V2: '/dm/v2',
  DOCS_API_V3: '/dm/v3',
  PKG_API_V1: '/packages/v1',
  EXPORT_API_V1: '/pes/v1',
  EXPORT_API_V2: '/pes/v2',
  REPORT_API_V2: '/reports/v2',
  HQ_API_ADMIN_V1: '/bim360/admin/v1',
  HQ_API_ADMIN_V2: '/bim360/admin/v2',
  OSS_EXT_V2: '/oss-ext/v2',
  RVT_UPGRADE_V1: '/revitupgrader/v1',
  PADD_V1: '/proxy/bridge/v1',
  PADD_V2: '/proxy/bridge/v2',
  OXYGEN_V1: '/identity/v1',
  ACC_ADMIN_V1: '/construction/admin/v1',
  QTO_V1: '/qto/v1',
  DATA_V1: '/data/v1',
  BC_INTERNAL: '/construction/buildingconnected/internal',
  // Hosts
  DOWNLOAD_HOST: 'https://download.docs.b360.autodesk.com',
  MARKUP_HOST: 'https://io.plangrid.com',
  PG_HOST: 'https://io.app.plangrid.com',
  BEBOP_V1: '/bebop/v1',
  SPECS_V1: '/construction/specs/v1',
  AUTOMATION_V1: '/automate/v1'
}), DOCS_REGIONS.EMEA, _defineProperty(_defineProperty({}, DOCS_ENVS.STAGING, {
  REGION_PATH: '/regions/eu',
  DOCS_API_CPV1: '/dm-staging/v1/regions/eu/cmd-staging',
  DS_V2: '/derivativeservice/v2/regions/eu',
  MD_V2: '/modelderivative/v2/regions/eu',
  DOWNLOAD_HOST: 'https://download.docs.acc-staging.autodesk.eu'
}), DOCS_ENVS.PRODUCTION, {
  REGION_PATH: '/regions/eu',
  DOCS_API_CPV1: '/dm/v1/regions/eu/cmd',
  DS_V2: '/derivativeservice/v2/regions/eu',
  MD_V2: '/modelderivative/v2/regions/eu',
  MARKUP_HOST: 'https://io.plangrid.be',
  DOWNLOAD_HOST: 'https://download.docs.acc.autodesk.eu',
  PG_HOST: 'https://io.app.plangrid.be'
})), DOCS_REGIONS.FEDRAMP, _defineProperty(_defineProperty({}, DOCS_ENVS.STAGING, {
  DOWNLOAD_HOST: 'https://download.docs.b360-staging.afg.us.autodesk.com'
}), DOCS_ENVS.PRODUCTION, {
  DOWNLOAD_HOST: 'https://download.docs.b360.afg.us.autodesk.com'
})), DOCS_REGIONS.APAC, _defineProperty(_defineProperty({}, DOCS_ENVS.STAGING, {
  REGION_PATH: '/regions/apac',
  DOCS_API_CPV1: '/dm-staging/v1/regions/apac/cmd-staging',
  DS_V2: '/derivativeservice/v2/regions/apac',
  MD_V2: '/modelderivative/v2/regions/apac',
  MARKUP_HOST: 'https://io.aus-stg.planfront.net',
  DOWNLOAD_HOST: 'https://download.docs.acc-staging.apac.autodesk.com',
  PG_HOST: ' https://io.aus-stg.planfront.net'
}), DOCS_ENVS.PRODUCTION, {
  REGION_PATH: '/regions/apac',
  DOCS_API_CPV1: '/dm/v1/regions/apac/cmd',
  DS_V2: '/derivativeservice/v2/regions/apac',
  MD_V2: '/modelderivative/v2/regions/apac',
  MARKUP_HOST: 'https://io.plangrid.com.au',
  DOWNLOAD_HOST: 'https://download.docs.acc.apac.autodesk.com',
  PG_HOST: 'https://io.app.plangrid.com.au'
})), DOCS_REGIONS.AUS, _defineProperty(_defineProperty({}, DOCS_ENVS.STAGING, {
  REGION_PATH: '/regions/aus',
  DOCS_API_CPV1: '/dm-staging/v1/regions/aus/cmd-staging',
  DS_V2: '/derivativeservice/v2/regions/aus',
  MD_V2: '/modelderivative/v2/regions/aus',
  MARKUP_HOST: 'https://io.aus-stg.planfront.net',
  DOWNLOAD_HOST: 'https://download.docs.acc-staging.aus.autodesk.com',
  PG_HOST: ' https://io.aus-stg.planfront.net'
}), DOCS_ENVS.PRODUCTION, {
  REGION_PATH: '/regions/aus',
  DOCS_API_CPV1: '/dm/v1/regions/aus/cmd',
  DS_V2: '/derivativeservice/v2/regions/aus',
  MD_V2: '/modelderivative/v2/regions/aus',
  MARKUP_HOST: 'https://io.plangrid.com.au',
  DOWNLOAD_HOST: 'https://download.docs.acc.aus.autodesk.com',
  PG_HOST: 'https://io.app.plangrid.com.au'
}));
export var SUPPORT_GUID_TYPES = ['dwfx', 'rvt', 'dwf'];

// Add feature flags here. E.g. `NEW_FOLDER_TERMINOLOGY: 'show-docs-new-terminology'`
export var SDK_FEATURES = {};
var getFileType = function getFileType(fileType, extensions) {
  return extensions.reduce(function (mapping, extension) {
    mapping[extension] = fileType;
    return mapping;
  }, {});
};
export var FILE_MIME_TYPE = {
  FDX: 'application/vnd.autodesk.fdx',
  COMP: 'application/vnd.autodesk.composite'
};

/* eslint-disable */
// prettier-ignore
export var FILE_TYPE_MAPPING = _extends({
  '3ds': '3ds',
  dotx: 'dotx',
  dwg: 'dwg',
  dwf: 'dwf',
  dwfx: 'dwfx',
  f3d: 'f3d',
  idw: 'idw',
  ifc: 'ifc',
  iwm: 'iwm',
  mat: 'mat',
  max: 'max',
  maxc: 'maxc',
  mcr: 'mcr',
  ms: 'ms',
  mxp: 'mxp',
  nwd: 'nwd',
  nwc: 'nwc',
  obj: 'obj',
  pdf: 'pdf',
  potx: 'potx',
  ppsx: 'ppsx',
  ppt: 'ppt',
  rvt: 'rvt',
  rcp: 'rcp',
  odp: 'odp',
  ods: 'ods',
  odt: 'odt',
  vssx: 'vssx',
  xls: 'xls',
  xlsm: 'xlsm',
  xltx: 'xltx'
}, getFileType('archive', ['cab', '7z', 'aac', 'ace', 'alz', 'apk', 'at3', 'bke', 'arc', 'arj', 'ass', 'sas', 'b', 'ba', 'big', 'bik', 'bin', 'bkf', 'bzip2', 'bld', 'c4', 'cals', 'clipflair', 'clipflair', 'cpt', 'sea', 'daa', 'deb', 'dmg', 'ddz', 'dpe', 'egg', 'egt', 'ecab', 'ezip', 'ess', 'gho', 'ghs', 'gzip', 'gz', 'ipg', 'jar', 'lbr', 'lawrence', 'lbr', 'lqr', 'lha', 'lzh', 'lzip', 'lz', 'lzo', 'lzma', 'lzx', 'mbw', 'mpq', 'bin', 'nth', 'osz', 'pak', 'par', 'par2', 'paf', 'pyk', 'pk3', 'pk4', 'rar', 'rag', 'rpm', 'sen', 'sit', 'sitx', 'skb', 'tar', 'tgz', 'tb', 'tib', 'uha', 'uue', 'viv', 'vol', 'vsa', 'wax', 'z', 'zoo', 'zip']), getFileType('audio', ['aif', 'aifc', 'aiff', 'bwf', 'wav', 'la', 'pac', 'wv', 'wma', 'mp2', 'mp3', 'm4a', 'm4p', 'aac']), getFileType('docx', ['doc', 'docm', 'docx', 'dot', 'dotm', 'rtf']), getFileType('image', ['ase', 'art', 'blp', 'bmp', 'cd5', 'cit', 'cpt', 'cr2', 'cut', 'dds', 'dib', 'djvu', 'egt', 'exif', 'gif', 'gpl', 'grf', 'icns', 'ico', 'iff', 'ilbm', 'lbm', 'jng', 'jpg', 'jpeg', 'jp2', 'jps', 'miff', 'mng', 'msp', 'nitf', 'otb', 'pbm', 'pc1', 'pc2', 'pc3', 'pcf', 'pcx', 'pdn', 'pgm', 'pi1', 'pi2', 'pi3', 'pict', 'png', 'pnm', 'pns', 'ppm', 'psb', 'psd', 'pdd', 'psp', 'px', 'pxm', 'pxr', 'qfx', 'raw', 'rle', 'sct', 'sgi', 'rgb', 'int', 'bw ', 'tga', 'targa', 'icb', 'vda', 'vst', 'pix', 'tif', 'tiff', 'vtf', 'xbm', 'xcf', 'xpm']), getFileType('pptx', ['pot', 'potm', 'pps', 'ppsm', 'pptm', 'pptx']), getFileType('textfile', ['602', 'abw', 'acl', 'afp', 'ami', 'ans', 'asc', 'aww', 'ccf', 'cwk', 'dbk', 'egt', 'epub', 'ezw', 'fdx', 'ftm', 'ftx', 'gdoc', 'html', 'hwp', 'hwpml', 'log', 'lwp', 'mbp', 'md', 'mcw', 'mobi', 'nb', 'nbp', 'odm', 'ott', 'omm', 'pages', 'pap', 'pdax', 'quox', 'rpt', 'sdw', 'se', 'stw', 'sxw', 'tex', 'info', 'troff', 'txt', 'uof', 'uoml', 'via', 'wpd', 'wps', 'wpt', 'wrd', 'wrf', 'wri', 'xhtml', 'xml', 'xps']), getFileType('video', ['aaf', 'avi', '3gp', 'flv', 'mp4', 'mpeg', 'mpg', 'mpe', 'ogg', 'swf', 'wmv', 'wtv']), getFileType('vsdx', ['vsd', 'vsdm', 'vsdx']), getFileType('xlsx', ['csv', 'xlsb', 'xlsx']));

// /////////////////////////////////////////////////////////////////// //
/* Excel
  view
    csv, ods, xls, xlsb, xlsm, xlsx
  edit
    ods, xlsb, xlsm, xlsx
PowerPoint
  view
    odp, pot, potm, potx, pps, ppsm, ppsx, ppt, pptm, pptx
  edit
    odp, ppsx, pptx
Visio
  view
    vsd, vsdm, vsdx
  edit
    vsdx
Word
  view
    doc, docm, docx, dot, dotm, dotx, odt, rtf
  edit
    docm, docx, odt
WopiTest
  view
    wopitest
    wopitestx
  edit
    wopitest
    wopitestx
*/
// /////////////////////////////////////////////////////////////////// //
// prettier-ignore
export var OFFICE_FILE_EDITABLE_EXTS = ['docm', 'docx', 'odt',
// Word
'ods', 'xlsb', 'xlsm', 'xlsx',
// Excel
'odp', 'ppsx', 'pptx',
// Power point
'vsdx',
// Viso
'wopitest', 'wopitestx' // For WOPI test
];

// prettier-ignore
export var OFFICE_FILE_VIEWABLE_EXTS = [].concat(OFFICE_FILE_EDITABLE_EXTS, ['doc', 'dot', 'dotm', 'dotx', 'rtf',
// Word
'xls', 'csv',
// Excel
'pot', 'potm', 'potx', 'pps', 'ppsm', 'ppt', 'pptm',
// Power point
'vsd', 'vsdm' // Viso
]);
export var ENTITY_TYPE = {
  DOCUMENT: 'DOCUMENT',
  REVIEW_DOCUMENT: 'REVIEW_DOCUMENT',
  SEED_FILE: 'SEED_FILE'
};

/* eslint-enable */
export var ENTITY_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING',
  EXTRACTION: 'EXTRACTION',
  PROCESSING_ABORTED: 'PROCESSING_ABORTED',
  PROCESSING_COMPLETE: 'PROCESSING_COMPLETE',
  PROCESSING_SUSPEND: 'PROCESSING_SUSPEND',
  PROCESSING_COPYING: 'PROCESSING_COPYING',
  PROCESSING_PROMOTING: 'PROCESSING_PROMOTING',
  EXTRACTION_PENDING: 'EXTRACTION_PENDING',
  PROCESSING_SUCCESS: 'PROCESSING_SUCCESS',
  PROCESSING_FAILED: 'PROCESSING_FAILED'
};
export var V2_PERMISSION_API_KEY_MAP = {
  oxygenId: 'autodeskId',
  id: 'subjectId',
  type: 'subjectType',
  accessType: 'userType',
  status: 'subjectStatus'
};
export var ACTIVITY_TIME_GROUP = {
  'activity.today': 'today',
  'activity.yesterday': 'yesterday',
  'activity.last_week': 'lastWeek',
  'activity.last_month': 'lastMonth',
  'activity.last_three_month': 'lastThreeMonth',
  'activity.older': 'older'
};
export var FOLDER_TYPE = {
  PLAN: 'plan',
  PROJECT_FILE: 'normal',
  SHARED: 'shared',
  VIRTUAL: 'container_virtual'
};

// Copied from https://git.autodesk.com/BIM360/BIM360DM/blob/master/config/executable_file_types.yml
// prettier-ignore
export var EXECUTABLE_FILE_TYPES = ['ade', 'adp', 'app', 'asp', 'bas', 'bat', 'cer', 'chm', 'class', 'cmd', 'com', 'command', 'cpl', 'crt', 'csh', 'exe', 'fxp', 'hex', 'hlp', 'hqx', 'hta', 'htm', 'html', 'inf', 'ini', 'ins', 'isp', 'its', 'jar', 'job', 'js', 'jse', 'ksh', 'lnk', 'lzh', 'mad', 'maf', 'mag', 'mam', 'maq', 'mar', 'mas', 'mau', 'mav', 'maw', 'mda', 'mde', 'mdt', 'mdw', 'mdz', 'msc', 'msi', 'msp', 'mst', 'ocx', 'ops', 'pcd', 'pkg', 'pif', 'prf', 'prg', 'pst', 'reg', 'scf', 'scr', 'sct', 'sea', 'sh', 'shb', 'shs', 'svg', 'tmp', 'ps1', 'url', 'vb', 'vbe', 'vbs', 'vsmacros', 'vss', 'vst', 'vsw', 'webloc', 'ws', 'wsc', 'wsf', 'wsh', 'zlo', 'zoo'];
export var UPLOAD_SHEETS_EXTENSION = ['rvt', 'pdf', 'dwg', 'dwf', 'dwfx', 'ifc'];
export var UPLOAD_LINKED_EXTENSION = ['rvt', 'dwg', 'dwf', 'dwfx'];
export var MAT_FILE_SIGNATURE = [208, 207, 17, 224, 161, 177, 26, 225];
export var UPLOAD_ERRORS = {
  BROWSER_ONLY: 'BROWSER_ONLY',
  // Only support browser to upload with oss sdk
  INVALID_FILE: 'INVALID_FILE',
  // File validation error like file without name, empty size
  INVALID_FILE_TYPE: 'INVALID_FILE_TYPE',
  // File type validation error like exe file
  FILESIZE_EXCEEDED: 'FILESIZE_EXCEEDED',
  // Filesize is more than 5TB
  STORAGE_URN_FAILURE: 'STORAGE_URN_FAILURE',
  // Failed to request a storage urn
  OSS_DELETE_FAILURE: 'OSS_DELETE_FAILURE',
  // Failed to delete file from oss
  FILE_NAME_TOO_LONG: 'FILE_NAME_TOO_LONG',
  // File name validation error
  FILE_NAME_INVALID_CHARS: 'FILE_NAME_INVALID_CHARS',
  FILE_NAME_RESERVED: 'FILE_NAME_RESERVED',
  FILE_NAME_END_PERIOD: 'FILE_NAME_END_PERIOD',
  INVALID_MAT_FILE: 'INVALID_MAT_FILE',
  // Rvt file validate error
  INVALID_RVT_FILE: 'INVALID_RVT_FILE',
  // Mat file validate error
  UPLOAD_FAILURE: 'UPLOAD_FAILURE',
  // Failed to update by oss sdk
  UPLOAD_INVALID_FAILURE: 'UPLOAD_INVALID_FAILURE',
  // File uploaded but actually invalid at oss
  UPLOAD_COMMAND_FAILURE: 'UPLOAD_COMMAND_FAILURE',
  // Create upload command failure
  UPLOAD_API_FAILURE: 'UPLOAD_API_FAILURE' // Create upload api failure
};
export var TRANSMITTAL_LIMIT = {
  DOCUMENTS: 200
};

// Use a fixed time to ensure attribute value not offset at different timezone.
export var ATTRIBUTE_TIME_SUFFIX = '11:59:59';
export var SHEETS_CONTAINER_TYPES = {
  BUILD: 'Build',
  QTO: 'QTO'
};
export var EXT_META_PROPERTY_TYPES = {
  STRING: 'STRING',
  DECIMAL: 'DECIMAL',
  INTEGER: 'INTEGER',
  DATETIME: 'DATETIME',
  BOOLEAN: 'BOOLEAN'
};